// ─── Notification Endpoints ───────────────────────────────────────────────────

export const SEND_PUSH_NOTIFICATION = 'admin/sendNotification';
export const API_GET_NOTIFICATION = '/admin/notifications';
export const API_MANAGE_NOTIFICATION = '/admin/manage-notification';
export const API_GET_NOTIFICATION_COUNT = '/admin/notification-count';
export const API_UPDATE_FIREBASE_TOKEN = '/admin/updateFirebaseToken';
